import { useEffect, useState } from "react";
import { useStore } from "../../state/state.ts";
import './input-plz.css'
import TextInput from "./input-text.tsx";
import { PLZ_VALIDATION } from "../../config.ts";

export default function PlzInput (props: {
  label?: string,
  value: string,
  placeholder?:number,
  disabled?: boolean,
  onChange: (value: string) => void,
  onBlur?: () => void,
}){
  const [valid, setValid] = useState(false);
  const api_check_zip = useStore((state)=>state.api_check_zip);
  const region_name = useStore((state)=>state.region_name);

  const validate = async (v:string)=>{
    return  PLZ_VALIDATION(v) && (await api_check_zip(v));
  };
 
  //console.log("plz", region_name);

  return <TextInput type="number" hint="Bitte eine gültige Postleitzahl z.B. 1234 eingeben." postfix={valid ? region_name : ""} label={props.label} value={props.value ? props.value.toString() : ""} placeholder={props.placeholder ? props.placeholder.toString() : ""} disabled={props.disabled}  onBlur={props.onBlur} onChange={props.onChange} 
  validate={validate}
  onValidate={setValid}/>
}
